import { useRequest } from 'ahooks'
import { useTheme } from 'antd-style'

import { activateAuctionApplyApi } from '@eastcoal/api/trade/applyOperation/activateAuctionApply'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'

import { ApplyEnableButtonProps } from './interface'

export const ApplyEnableButton = ({ record }: ApplyEnableButtonProps) => {
  const { message } = useFeedback()

  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const { refresh } = useRequest(
    () =>
      activateAuctionApplyApi({
        id: record.id,
        pass: true
      }),
    {
      manual: true,
      onSuccess() {
        message.success('激活成功')
        reload()
      }
    }
  )

  const theme = useTheme()

  return record.status === ApplyStatus.FORBIDDEN ? (
    <ConfirmButton
      message='确定激活吗？'
      type='link'
      style={{
        color: theme.green
      }}
      onConfirm={refresh}
    >
      激活
    </ConfirmButton>
  ) : null
}
